import api from "@/lib/api";

export async function getSolicitacaoDash({ setorFilter, filter, cpf, servico, atendente, page }) {
  const { data } = await api.get("/secretaria-digital/solicitacoes/dash", { params: { setor: setorFilter, filter, cpf, servico, atendente, page } })
  return data
}